import React from 'react'
import { ICustomerWithFavorites } from '../types/customerWithFavorites'
import styled from 'styled-components'
import StarIcon from '../../icons/IconLib/StarIcon'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

interface ICustomerFavoritesItemProps extends ICustomerWithFavorites {
  isLoading: boolean
  createFavorite: (customerId: number) => void
  deleteFavorite: (customerId: number) => void
}

const CustomerFavoritesItem = ({
  isLoading,
  createFavorite,
  deleteFavorite,
  CustomerID,
  Customer_Name,
  isFavorite,
}: ICustomerFavoritesItemProps) => {

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: CustomerID.toString() })

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  const handleFavorite = () => {
    if (isFavorite) {
      deleteFavorite(CustomerID)
    } else {
      createFavorite(CustomerID)
    }
  }

  return (
    <Wrapper
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      $isDragging={isDragging}
    >
      <Item>
        {Customer_Name.trim()}
      </Item>
      <Item
        onClick={handleFavorite}
        $isFavorite={isFavorite}
      >
        <StarIcon fill />
      </Item>
    </Wrapper>
  )
}

const Wrapper = styled.div<{ $isDragging?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.4em;
  border-radius: 30px;
  background-color: ${({ $isDragging }) => $isDragging ? '#f5f5f5' : '#fff'};
  border: ${({ $isDragging }) => $isDragging ? '2px dashed #ccc' : '2px solid transparent'};
  opacity: ${({ $isDragging }) => $isDragging ? 0.5 : 1};
  transition: all 0.2s ease;
  touch-action: none;
`
const Item = styled.div<{ $isFavorite?: boolean }>`
  cursor: pointer;
  color: ${({ $isFavorite }) => $isFavorite ? '#FFCA28' : 'gray'};
`

export default CustomerFavoritesItem
